import { createContext, useState } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const user1 =  JSON.parse(sessionStorage.getItem("user"))
  const [user, setUser] = useState(user1);

  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user")
    setUser(null);     
  };

  return (
    <AuthContext.Provider value={{ user, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
